import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue')
  },
  {
    path: '/live-games',
    name: 'LiveGames',
    component: () => import('@/views/LiveGames.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/DownloadPage.vue')
  },
  {
    path: '/about-sunbet',
    name: 'AboutSunbet',
    component: () => import('@/views/AboutSunbet.vue')
  },
  {
    path: '/egame',
    name: 'Egame',
    component: () => import('@/views/EgamePage.vue')
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import('@/views/MobilePage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
